/**
 * Synchronously initializes language from iframelang URL parameter
 * This must run before React components mount to ensure correct language on initial render
 * @returns {string|null} The language value that was set, or null if not set
 */
const initializeIframeLanguage = () => {
  // Check if in iframe mode (synchronously)
  let isInIframe = false;
  try {
    isInIframe = window.self !== window.top;
  } catch (e) {
    // If there's a cross-origin error, we're likely in an iframe
    isInIframe = true;
  }

  // Only process if in iframe mode
  if (!isInIframe) {
    return null;
  }

  // Check for iframelang parameter in URL
  const searchParams = new URLSearchParams(window.location.search);
  const iframeLang = searchParams.get('iframelang');

  if (!iframeLang) {
    return null;
  }

  // Validate and normalize the language value (case-insensitive)
  const normalizedLang = iframeLang.trim().toLowerCase();
  let validLang = null;

  if (normalizedLang === 'spanish' || normalizedLang === 'español' || normalizedLang === 'espanol') {
    validLang = 'Spanish';
  } else if (normalizedLang === 'english' || normalizedLang === 'en' || normalizedLang === 'eng') {
    validLang = 'English';
  }

  if (validLang) {
    // Set language in localStorage immediately (synchronously)
    localStorage.setItem('language', validLang);
    return validLang;
  }

  return null;
};

export default initializeIframeLanguage;

